import moment from 'moment-timezone';
import FileDownload from 'js-file-download';

import * as SessionHelper from '../../helpers/sessionHelper';

export class GetSummaryReportRequest {
  private clientId: string;

  private formData: any;

  private name: string;

  constructor(name: string, clientId: string, formData: any) {
    this.clientId = clientId;
    this.formData = formData;
    this.name = name;
  }

  async downloadFile() {
    const fromDate = moment(this.formData.dateFrom).format('YYYY-MM-DD');
    const toDate = moment(this.formData.dateTo).format('YYYY-MM-DD');
    const urlPath = `${process.env.REACT_APP_API_URL}/clients/${this.clientId}/summary-report/?dateFrom=${fromDate}&dateTo=${toDate}`;

    const headers = new Headers();
    headers.append('Authorization', `Bearer ${SessionHelper.getSessionToken()}`);
    headers.append('responseType', 'blob');
    // @ts-ignore
    await fetch(urlPath, { headers, method: 'GET' })
      .then(res => res.blob())
      .then(blob => {
        const universityName = this.name.replace(/\s+/g, '-').toLowerCase();
        const firstLetter = universityName.substr(0, 1);
        const name = firstLetter.toUpperCase() + universityName.substr(1);
        FileDownload(
          blob,
          `${name} ${moment(this.formData.dateFrom).format('DD MMM YYYY')} to ${moment(this.formData.dateTo).format(
            'DD MMM YYYY',
          )}.pdf`,
        );
      });
  }
}
